import GlobalDataFactory from '../factories/GlobalDataFactory';
import type { OrderPageMode } from '@/presentation/constants/OrderPageModeConstants';

export default class GlobalData {
    private constructor() {}

    public static get(mode: OrderPageMode, productId: number, ref: string) {
        const useCase = GlobalDataFactory.makeGetUseCase();
        return useCase.invoke(mode, productId, ref);
    }
}
